<script>
import cst from './../../assets/js/dashboard/utilities'
import { Bar } from "vue-chartjs";

export default {
    extends: Bar,
    props:{
        barChartData: {type: Array}
    },
    data(){
        return{
            monthArr: cst.monthArr
        }
    },
    computed: {
        chartData() {
            return this.barChartData;
        }
    },
    watch: {
        barChartData() {
            this.setBarChart();
        }
    },
    methods:{
        setBarChart(){
            this.renderChart(
            {
                labels: this.monthArr,
                datasets: this.chartData
            },
            { responsive: true, maintainAspectRatio: false }
            );
        },
    },
    mounted() {
        this.setBarChart()
    }
};
</script>
